"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var slownie_1 = require("./slownie");
var padNumber_1 = require("./padNumber");
var mround_1 = require("./mround");
function zlTekst(liczbazl) {
    switch (liczbazl) {
        case 1:
            return 'złoty';
    }
    var lz = liczbazl % 100;
    if (lz >= 5 && lz <= 20)
        return 'złotych';
    switch (lz % 10) {
        case 2:
        case 3:
        case 4:
            return 'złote';
    }
    return 'złotych';
}
function grTekst(liczbagr) {
    switch (liczbagr) {
        case 1:
            return 'grosz';
    }
    var lz = liczbagr % 100;
    if (lz >= 5 && lz <= 20)
        return 'groszy';
    switch (lz % 10) {
        case 2:
        case 3:
        case 4:
            return 'grosze';
    }
    return 'groszy';
}
/**
 * Zamiana kwoty na słownie ze słowem złoty/ch
 * @param kwota kwota do zamiany
 * @param currency co wstawić jako walutę, domyslnie automatycznie dopasowuje odmianę `złoty`
 * @param forceShowgr czy wymusić grosze w przypadku gdy liczba groszy jest równa 0
 */
function slowniezl(kwota, currency, forceShowgr) {
    if (currency === void 0) { currency = ''; }
    if (forceShowgr === void 0) { forceShowgr = false; }
    if (kwota < 0) {
        kwota = kwota * -1;
    }
    var strKwotaSl = '';
    //strKwotaSl = ToWords(liczba_zlotych(kwota)) + " zł " + ToWords(liczba_groszy(kwota)) + " gr.";
    //strKwotaSl = ToWords(liczba_zlotych(kwota)) + " zł " + String + " gr.";
    var zlote = Math.floor(kwota);
    var grosze = mround_1.default((kwota - zlote) * 100, 0);
    if (!currency)
        currency = zlTekst(zlote);
    strKwotaSl = slownie_1.default(zlote) + ' ' + currency;
    if (grosze !== 0 || forceShowgr) {
        strKwotaSl += ' ' + padNumber_1.default(grosze, 2) + '/100';
    }
    return strKwotaSl;
}
exports.default = slowniezl;
//# sourceMappingURL=slowniezl.js.map